import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { getI18n } from '../lib/i18n';
const SearchInput = ({ value, onChange, onClear, autoFocus = false, }) => {
    const i18n = getI18n();
    const inputRef = useRef(null);
    const [debouncedValue, setDebouncedValue] = useState(value);
    // Sync external value changes into internal state
    useEffect(() => {
        setDebouncedValue(value);
    }, [value]);
    // Debounce input changes (150ms)
    useEffect(() => {
        const timer = setTimeout(() => {
            onChange(debouncedValue);
        }, 150);
        return () => clearTimeout(timer);
    }, [debouncedValue, onChange]);
    // Auto-focus
    useEffect(() => {
        if (autoFocus && inputRef.current) {
            inputRef.current.focus();
        }
    }, [autoFocus]);
    const handleChange = (e) => {
        setDebouncedValue(e.target.value);
    };
    const handleClear = () => {
        setDebouncedValue('');
        onClear();
        inputRef.current?.focus();
    };
    return (_jsxs("div", { className: "eno-search-input-wrapper", children: [_jsx("svg", { className: "eno-search-input-icon", width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M12.9167 11.6667H12.2583L12.025 11.4417C12.8417 10.4917 13.3333 9.25833 13.3333 7.91667C13.3333 4.925 10.9083 2.5 7.91667 2.5C4.925 2.5 2.5 4.925 2.5 7.91667C2.5 10.9083 4.925 13.3333 7.91667 13.3333C9.25833 13.3333 10.4917 12.8417 11.4417 12.025L11.6667 12.2583V12.9167L15.8333 17.075L17.075 15.8333L12.9167 11.6667ZM7.91667 11.6667C5.84167 11.6667 4.16667 9.99167 4.16667 7.91667C4.16667 5.84167 5.84167 4.16667 7.91667 4.16667C9.99167 4.16667 11.6667 5.84167 11.6667 7.91667C11.6667 9.99167 9.99167 11.6667 7.91667 11.6667Z", fill: "currentColor" }) }), _jsx("input", { ref: inputRef, type: "text", className: "eno-search-input", value: debouncedValue, onChange: handleChange, placeholder: i18n.placeholder, "aria-label": i18n.searchLabel }), debouncedValue && (_jsx("button", { className: "eno-search-input-clear", onClick: handleClear, "aria-label": i18n.clearSearch, children: _jsx("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z", fill: "currentColor" }) }) }))] }));
};
export default SearchInput;
